import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { useAccessToken } from '@salesforce/commerce-sdk-react';
import { Box, IconButton, Img } from '@salesforce/retail-react-app/app/components/shared/ui';
import SliderInitiator from '../../../slider-initiator';
import useCustomFetch from '../../../../hooks/useFetchContent';
import { promoBannerStyle, styleArrowIcon } from './index.style';
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils';
import { noop } from '@salesforce/retail-react-app/app/utils/utils';

const PromoBanner = ({ slotIDs, setPromoBannerInHeaderIsActive = noop }) => {
    const { token } = useAccessToken();
    const { response, error } = useCustomFetch(token, slotIDs, true);
    const boxRef = useRef(null);

    const [currentSlide, setCurrentSlide] = useState(0);
    const [slideCount, setSlideCount] = useState(0);


    const NextArrow = (props) => {
        const { onClick, currentSlide, slideCount } = props;
        const disabled = currentSlide === slideCount - 1;

        return (
            <IconButton
                onClick={disabled ? undefined : onClick}
                isDisabled={disabled}
                className="arrow next-arrow"
            >
                <Img sx={styleArrowIcon} src={getAssetUrl('static/img/header/rightArrow.svg')} />
            </IconButton>
        );
    };

    const PrevArrow = (props) => {
        const { onClick, currentSlide } = props;
        const disabled = currentSlide === 0;

        return (
            <IconButton
                onClick={disabled ? undefined : onClick}
                isDisabled={disabled}
                className="arrow prev-arrow"
            >
                <Img sx={styleArrowIcon} src={getAssetUrl('static/img/header/leftArrow.svg')} />
            </IconButton>
        );
    };

    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                },
            },
        ],
        beforeChange: (oldIndex, newIndex) => {
            setCurrentSlide(newIndex);
        },
        afterChange: (current) => {
            setCurrentSlide(current);
        },
        onInit: (slider) => {
            const count = slider?.props?.children?.length || 0;
            setSlideCount(count);
            setCurrentSlide(0);
        }
    };

    useEffect(() => {
        if (boxRef.current && response) {
            const slideContainer = boxRef.current.querySelectorAll('.slider');
            slideContainer.forEach((container) => {
                const slideElements = container.querySelectorAll('.slide-item');
                if (slideElements.length > 1) {
                    const slidesArray = Array.from(slideElements).map(slide => slide.outerHTML);
                    container.innerHTML = '';  // Clear the static slider content

                    const root = ReactDOM.createRoot(container);
                    root.render(<SliderInitiator slidesHtml={slidesArray} settings={settings} />);
                }
                setSlideCount(slideElements.length);
                if (slideElements?.length > 0) {
                    setPromoBannerInHeaderIsActive(true)
                } else {
                    setPromoBannerInHeaderIsActive(false);
                }
            });
        }
    }, [response]);

    if (!response || error) return null;

    return (
        <Box
            ref={boxRef}
            sx={promoBannerStyle}
            dangerouslySetInnerHTML={{ __html: response }}
        />
    );
};

export default PromoBanner;
